import "../css/message.css";
import classnames from "classnames";

function create(msg, classname, time = 5000) {
  let div = document.createElement("em");
  div.className = classnames("g-message", classname);
  div.innerHTML = msg;
  if (!window.document.querySelector("#msgbox")) {
    createBox();
  }
  window.document.querySelector("#msgbox").appendChild(div);
  setTimeout(() => {
    div.className = classnames("g-message", classname, "close");
    setTimeout(() => {
      window.document.querySelector("#msgbox").removeChild(div);
    }, 5000);
  }, time);
}

function createBox() {
  if (window.document.querySelector("#msgbox")) return;
  let div = document.createElement("div");
  div.id = "msgbox";
  div.className = "g-msgbox alert";
  window.document.body.appendChild(div);
}
window.addEventListener("load", createBox, false);

function info(msg, t) {
  create(
    `<i class="fa fa-info text-info"></i><span>${msg}</span>`,
    "alert-info",
    t
  );
}
function warn(msg, t) {
  create(
    `<i class="fa fa-warning text-warning"></i><span>${msg}</span>`,
    "alert-warning",
    t
  );
}
function error(msg, t) {
  create(
    `<i class="fa fa-times text-danger"></i><span>${msg}</span>`,
    "alert-danger",
    t
  );
}
function success(msg, t) {
  create(
    `<i class="fa fa-check text-success"></i><span>${msg}</span>`,
    "alert-success",
    t
  );
}
function tip(msg, t) {
  create(`<span>${msg}</span>`, "success", t);
}

export default {
  info,
  warn,
  error,
  success,
  tip,
};
